<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.workId" hidden/>

        <b-row>

          <t-input
              v-model="form.name"
              :add-error="error.name"
              cols="9"
              required
              label="Título do Trabalho"/>

          <t-input v-model="form.workCodeLabel"
                   v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.workCodeLabel" upper cols="3"
                   label="Cód. Trabalho"
                   help="Código inserido manualmente conforme configurado em Mapeamento > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.workCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.workCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Trabalho"
                   help="Código inserido automaticamente conforme configurado em Mapeamento > Configurações > Parâmetros"
          />

        </b-row>

        <t-input-person customer :status="status" :command="command" required :add-error="error.customerId"
                        v-model="form.customerId"/>

        <b-row>

          <t-input
              cols="6"
              v-model="form.startJob"
              label="Data início do trabalho"
              date
          />

          <t-input
              cols="6"
              v-model="form.finishJob"
              label="Data término do trabalho"
              date
          />

        </b-row>

        <b-row>

          <t-input
              cols="6"
              textarea
              v-model="form.contractorName"
              max-length="255"
              label="Contratante - Denominação"
          />

          <t-input
              cols="6"
              textarea
              max-length="255"
              v-model="form.contractorDocument"
              label="Contratante - Documento"
          />

        </b-row>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import SettingType from "@/model/types/resource/SettingType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeSpotFolderForm',
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "workId",
      form: {
        workId: 0,
        workNumber: 0,
        typeEnterpriseId: 0,
        customerId: 0,
        contractorName: "",
        contractorDocument: "",
        startJob: "",
        finishJob: "",
        name: "",
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        workCodeLabel: "",
        customerId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

